module.exports = __webpack_public_path__ + "img/systemInvFlow.706c578b.gif";